import React from "react";
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";

// =============================================================
// Hộp xác nhận dùng chung cho cổng nhân viên.
// Dựng theo đúng modal "Đăng xuất" của AccountLanding (vốn khớp
// Alert.alert của mobile-app-v2): overlay mờ + hộp trắng bo 18px,
// tiêu đề + mô tả + 2 nút Huỷ / Xác nhận.
// =============================================================

const APP_BLACK = "#18212F";
const PRIMARY = "#4081EB";
const DANGER = "#E5484D";
const SOFT = "#EEF5FF";

const ConfirmDialog = ({
  isOpen,
  title,
  description,
  confirmText = "Xác nhận",
  cancelText = "Huỷ",
  danger = false,
  loading = false,
  onConfirm,
  onClose,
}) => {
  if (!isOpen) return null;

  const close = () => {
    if (!loading) onClose?.();
  };

  return (
    <Flex
      position="fixed"
      inset="0"
      bg="rgba(0,0,0,0.45)"
      align="center"
      justify="center"
      px="20px"
      zIndex={60}
      onClick={close}
    >
      <Box
        bg="white"
        borderRadius="18px"
        p="16px"
        w="100%"
        maxW="360px"
        onClick={(e) => e.stopPropagation()}
      >
        <Text fontSize="17px" fontWeight={700} color={APP_BLACK}>
          {title}
        </Text>
        {description ? (
          <Text fontSize="14px" color={APP_BLACK} mt="8px">
            {description}
          </Text>
        ) : null}

        <Flex gap="10px" mt="16px">
          <Flex
            as="button"
            type="button"
            flex="1"
            h="44px"
            borderRadius="8px"
            bg={SOFT}
            align="center"
            justify="center"
            onClick={close}
            disabled={loading}
            opacity={loading ? 0.6 : 1}
          >
            <Text fontSize="14px" fontWeight={600} color={APP_BLACK}>
              {cancelText}
            </Text>
          </Flex>

          <Flex
            as="button"
            type="button"
            flex="1"
            h="44px"
            borderRadius="8px"
            bg={danger ? DANGER : PRIMARY}
            align="center"
            justify="center"
            gap="8px"
            onClick={() => !loading && onConfirm?.()}
            disabled={loading}
            opacity={loading ? 0.6 : 1}
          >
            {loading ? <Spinner size="sm" color="white" /> : null}
            <Text fontSize="14px" fontWeight={600} color="white">
              {confirmText}
            </Text>
          </Flex>
        </Flex>
      </Box>
    </Flex>
  );
};

export default ConfirmDialog;
